import React from "react";
import {Card, Tooltip} from "@shopify/polaris";
import { ArtifactGrid } from "../ArtifactGrid";
import ArtifactProps from "./ElementProps";
import styles from "./ImageElementCard.module.css";
import ElementsContextType from "../../types/ElementsContextType";
import { ElementsContext } from "../contexts/ElementsContext";
import { Tick } from "../Indicators";
import { AssetType } from "../../types/AssetType";
import {addImageToDeleteList} from "../../store/actions/Inspections";
import {useDispatch, useSelector} from "react-redux";
import SurveyorCompletionStatus from "../../types/SurveyorCompletionStatus";
import {PortalState} from "../../types/PortalState";


export default function ArtifactElementCard({ element , deleteDialogCallback }: Readonly<ArtifactProps>) {
    const dispatch = useDispatch();
    const { openGallery } = React.useContext(
        ElementsContext
    ) as ElementsContextType;


    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const localUpdateTime = useSelector(
        (state: any) => state.portal.activeInspection?.localUpdateTime
    );

    const surveyorCompletionStatus: SurveyorCompletionStatus | undefined =
        useSelector(
            (state: PortalState) =>
                state.portal.activeInspection?.SurveyorCompletionStatus
        );


    const dispatchImageElementsToDelete = () => {
        const imageIds = element.Images.map(i => i.id);

        imageIds.forEach((assetId: string) => {
            dispatch(
                addImageToDeleteList({
                    elementId: element.Id,
                    assetId: assetId
                })
            );

        })
    }

    const openDeleteDialog = () => {
        dispatchImageElementsToDelete();
        if(deleteDialogCallback != undefined){
            deleteDialogCallback(true);
        }
    }

    const deleteButton = () => {
        if(!element.Images.length || surveyorCompletionStatus?.PhotosComplete){
            return null
        }

        const deleteMessage = "Delete all images"

        return <Tooltip content={deleteMessage}>
            <img
                alt={deleteMessage}
                src={"/images/Roll-Over-Delete2.svg"}
                className={styles.deleteButton}
                onClick={openDeleteDialog}
            />

        </Tooltip>

    }


    return (
        <Card>
            <section
                className={styles.card}
                data-cy={element.Name.replace(/\s/g, "")}
            >
            {/* // Card header */}
                <div className={styles.cardHeader}>
                    <div className={styles.name}>
                        <div
                            className={styles.heading}
                            onClick={() => {
                                openGallery(element);

                            }}
                        >
                            {element.Name}
                        </div>
                        <Tick element={element}/>
                        {deleteButton()}
                    </div>
                    <div className={styles.smallText}>
                        {element.MinItems && element.MaxItems ? (
                            <div>
                                Min {element.MinItems}, Max {element.MaxItems}
                            </div>
                        ) : null}
                    </div>
                </div>

                {/* Card body */}
                <ArtifactGrid
                    assetType={AssetType.Image}
                    elementId={element.Id}
                    assetSize="small"
                />

                {/* Card Footer */}
                {element.PreliminaryReportDescription &&
                element.PreliminaryReportDescription.length > 0 ? (
                    <section className={styles.info}>
                        {element.PreliminaryReportDescription}
                    </section>
                ) : null}
            </section>
        </Card>
    );
}
